module.exports = __webpack_public_path__ + "img/37.9a362582.jpg";